const Cookies = {
    getCookie: (key) => {
        if (!key) {
            return null;
        }
        return (
            decodeURIComponent(
                document.cookie.replace(
                    new RegExp(
                        '(?:(?:^|.*;)\\s*' +
                            encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') +
                            '\\s*\\=\\s*([^;]*).*$)|^.*$'
                    ),
                    '$1'
                )
            ) || null
        );
    },
    setCookie: (key, value, end, path, domain, secure) => {
        if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) {
            return false;
        }
        let expires = '';
        if (end) {
            switch (end.constructor) {
                case Number:
                    expires =
                        end === Infinity
                            ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
                            : '; max-age=' + end;
                    break;
                case String:
                    expires = '; expires=' + end;
                    break;
                case Date:
                    expires = '; expires=' + end.toUTCString();
                    break;
                default:
                    break;
            }
        }
        document.cookie =
            encodeURIComponent(key) +
            '=' +
            encodeURIComponent(value) +
            expires +
            (domain ? '; domain=' + domain : '') +
            (path ? '; path=' + path : '') +
            (secure ? '; secure' : '');
        return true;
    }
};

export default Cookies;
